jQuery(document).ready(function($) {

    $('#roachVideoPoster').trigger('play');

    function copyToClipboard(copyText) {
      navigator.clipboard.writeText(copyText);
      alert("Copied the text: " + copyText);
    }

});
